import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Inject, PLATFORM_ID } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { AngularFireDatabase, AngularFireObject } from '@angular/fire/compat/database';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-our-portfolio',
  imports: [MatTabsModule, CommonModule],
  templateUrl: './our-portfolio.component.html',
  styleUrl: './our-portfolio.component.css'
})
export class OurPortfolioComponent {
    private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private db = inject(AngularFireDatabase);
  private platformId = inject(PLATFORM_ID);
  visitorCount: any = 0;
  visitorCountRef: AngularFireObject<any>;
  visitorCount$: Observable<any>;
  filteredWebCards: any[] = [];
  filteredSSMCards: any[] = [];
  filteredMobileCards: any[] = [];
  webCard = [];
  ssmCards = [];
  mobilecards = [];
  isBrowser: boolean;

  selectedTabIndex: number = 0;

  constructor(
  
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    console.log('📌 isBrowser:', this.isBrowser);

    if (this.isBrowser) {
      console.log('📡 Subscribing to Firebase database root...');
      this.db.object('/').valueChanges().subscribe({
        next: (data: any) => {
          console.log('✅ Firebase data received:', data);
         
            if(data   && (data.webCard?.length)){
               this.webCard = [...data.webCard];
            }
            if(data   && (data.ssmCards?.length)){
               this.ssmCards = [...data.ssmCards];
            }
            if(data   && (data.mobilecards?.length)){
               this.mobilecards = [...data.mobilecards];
            }
            console.log('🧩 webCard:', this.webCard);
            console.log('🧩 ssmCards:', this.ssmCards);
            console.log('🧩 mobilecards:', this.mobilecards);
            
            this.applyScrollLogicToTab();
         
        },
        error: (err) => {
          console.error('❌ Firebase subscription error:', err);
        }
      });
    }
  }

  ngOnInit() {
    console.log('🚀 ngOnInit called');
  }

  ngAfterViewInit() {
    
      this.applyScrollLogicToTab();
    
  }

  getUrl(card: any) {
    const bg = { 'background-image': `url('${card.image}')` };
    // console.log('🎨 Setting background:', bg);
    return bg;
  }

  gotoDetail(detail: any) {
    console.log('➡️ gotoDetail called for:', detail);
    // Example navigation
    // const name = detail.title.toLowerCase().split(" ")[0];
    // this.router.navigateByUrl('/ourproducts/' + name);
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTabIndex = event.index;
    console.log('🗂️ Tab changed — Selected Index:', this.selectedTabIndex);

    if (this.selectedTabIndex === 1) {
      console.log('⚙️ Applying scroll logic for second tab...');
      this.applyScrollLogicToTab();
    }
    if (this.selectedTabIndex === 0) {
      console.log('⚙️ Applying scroll logic for first tab...');
      this.applyScrollLogicToTab();
    }
  }

  applyScrollLogicToTab() {
    console.log('🔁 applyScrollLogicToTab called');
    

    if (this.isBrowser) {
      this.cdr.markForCheck();
      const cards = document.querySelectorAll('.product_card');
      console.log(`🃏 Found ${cards.length} .product_card elements`);

      cards.forEach((card, i) => {
        console.log(`🎴 Attaching hover logic to card #${i}`);

        card.addEventListener('mouseenter', async () => {
          console.log(`🖱️ Mouse enter on card #${i}`);
          const imageUrl = this.getComputedBackgroundImage(card);
          const imageHeight = await this.getImageHeight(imageUrl);
          const cardHeight = card.clientHeight;

          console.log(`📏 Image height: ${imageHeight}px, Card height: ${cardHeight}px`);

          const scrollDistance = Math.max(imageHeight - cardHeight, 0);
          const durationPer100px = 500;
          const duration = Math.max(1, scrollDistance / durationPer100px);

          const element = card as HTMLElement;
          element.style.transition = `background-position ${duration}s linear`;
          element.style.backgroundPosition = `center bottom`;

          console.log(`⬇️ Scrolling image by ${scrollDistance}px over ${duration}s`);
        });

        card.addEventListener('mouseleave', async () => {
          console.log(`🚪 Mouse leave on card #${i}`);
          const imageUrl = this.getComputedBackgroundImage(card);
          const imageHeight = await this.getImageHeight(imageUrl);
          const cardHeight = card.clientHeight;

          const scrollDistance = Math.max(imageHeight - cardHeight, 0);
          const durationPer100px = 800;
          const duration = scrollDistance / durationPer100px;

          const element = card as HTMLElement;
          element.style.transition = `background-position ${duration}s linear`;
          element.style.backgroundPosition = 'center top';

          console.log(`⬆️ Resetting image scroll to top over ${duration}s`);
        });
      });
    } else {
      console.warn('⚠️ Scroll logic skipped — not running in browser');
    }
  }

  getComputedBackgroundImage(el: Element): string {
        if (this.isBrowser) {
    const bg = window.getComputedStyle(el).backgroundImage;
    const clean = bg.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
    console.log('🧮 Computed background image URL:', clean);
        
    return clean;
        }else{
          return '';
        }
  }

  getImageHeight(src: string): Promise<number> {
    console.log('📸 Loading image to get height:', src);
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        console.log('✅ Image loaded — height:', img.height);
        resolve(img.height);
      };
      img.onerror = () => {
        console.error('❌ Failed to load image:', src);
        resolve(0);
      };
      img.src = src;
    });
  }
}
